import { API, authClient } from '../index'

export const uploadSingleFile = (file, folder, escapeRoomId) => {
	if (!file)
		return Promise.reject(new Error('File must be provided'))

	const formData = new FormData()
	formData.append('folder', folder)
	formData.append('file', file)
	if (escapeRoomId) formData.append('escapeRoomId', String(escapeRoomId))

	const URL = `${API}/file/single-file`
	return authClient().post(URL, formData)
}

/** Upload to user's private folder uploads/users/{userId}/ */
export const uploadUserMedia = (file, escapeRoomId) => uploadSingleFile(file, 'users', escapeRoomId)

/** List user's images and videos */
export const getUserMedia = (escapeRoomId) => {
	const q = escapeRoomId ? `?escapeRoomId=${encodeURIComponent(String(escapeRoomId))}` : ''
	return authClient().get(`${API}/file/user-media${q}`)
}

export const getUserMediaByUserId = (userId) =>
	authClient().get(`${API}/file/admin/user-media/${encodeURIComponent(String(userId || ""))}`)

export const uploadFilesGetLinks = async (files, folder) => {
	let tmp_filesURLs = {}

	for (const key in files) {
		if (files[key] !== null && files[key] !== undefined && files[key] !== '') {
			const res = await uploadSingleFile(files[key], folder)
			if (res && res.status === 200 && res.data?.fileURL)
				tmp_filesURLs[key] = res.data.fileURL
		}
	}

	return Object.values(tmp_filesURLs)
}